import { all, fork } from 'redux-saga/effects'

import ApiSagas from './api/sagas'
import AppSagas from './app/sagas'
import AuthSagas from './auth/sagas'
import DeclarationSagas from './declaration/sagas'
import PageSagas from './page/sagas'
import ConfigurationSagas from './configuration/sagas'
import TrackingSagas from './tracking/sagas'
import InstitutionsSagas from './institutions/sagas'

function* allListeners() {
  yield all([
    ApiSagas.listeners(),
    AppSagas.listeners(),
    AuthSagas.listeners(),
    DeclarationSagas.listeners(),
    PageSagas.listeners(),
    TrackingSagas.listeners(),
    ConfigurationSagas.listeners(),
    InstitutionsSagas.listeners(),
  ])
}

export default function* rootSaga() {
  yield fork(allListeners)
}
